import { gql } from "@apollo/client";

const UserDevicesSubscription = gql`
  subscription UserDevicessSubscription($userId: UUID!) {
    listen(topic: "user_device_update") {
      query {
        allUserDevices(
          condition: { userAppId: $userId }
          orderBy: DEVICE_ID_ASC
        ) {
          nodes {
            id
            deviceId
            deviceByDeviceId {
              deviceName
            }
          }
        }
      }
    }
  }
`;

const hash = "7a0f7590bb6bd6ca565cdad78a7785db38c9cbf94430949f55572c9e7d3db0ee";

export { UserDevicesSubscription, hash };
